import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { JsonMapperService } from '../../../../core/services/mapper/mapper.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LeurreSearch } from '../../models/leurre-search.model';
import { DateConverter } from '../../../../core/services/mapper/converters';

@Injectable({
    providedIn: 'root'
})
export class LeurresService {
    constructor(private readonly http: HttpClient, private readonly mapper: JsonMapperService) {}

    /**
     * Récupérer les leurres d'une commission'
     * @param idOrganisme - L'id de l'organisme
     * @param numeroCommission - Le numero de la commission
     * @param dateDebutCommission - La date de la commission
     * @param dateFinCommission - La date de la commission
     * @param numeroCVI - Le numéro de CVI
     * @param numeroEchantillon - Le numéro d'échantillon
     * @param libelleChiers - Liste des libellés des cahiers des charges
     */
    getCommissionLeurres(
        idOrganisme: number,
        dateDebutCommission: moment.Moment,
        dateFinCommission: moment.Moment,
        numeroCommission: string,
        numeroCVI: string,
        numeroEchantillon: string,
        libelleChiers: string[]
    ): Observable<LeurreSearch[]> {
        const dateConverter = new DateConverter();
        let params = new HttpParams();
        params = numeroCommission ? params.set('numeroCommission', numeroCommission) : params;
        params = dateDebutCommission ? params.set('dateDebutCommission', dateConverter.serialize(dateDebutCommission)) : params;
        params = dateFinCommission ? params.set('dateFinCommission', dateConverter.serialize(dateFinCommission)) : params;
        params = numeroCVI ? params.set('numeroCVI', numeroCVI) : params;
        params = numeroEchantillon ? params.set('numeroEchantillon', numeroEchantillon) : params;
        params = libelleChiers ? params.set('libelleCahierList', libelleChiers.join(',')) : params;
        return this.http
            .get<LeurreSearch[]>(`/api/declaration/private/organismes/${idOrganisme}/commissions/leurres`, { params })
            .pipe(map(leurres => this.mapper.deserializeArray(leurres, LeurreSearch)));
    }
}
